import React, { useState } from 'react';
import './Population.css';
import Pop from '../assets/PopulationCounty.png';
import PdfViewer1 from '../About/PdfViewer1';
import Loader from '../Loader/Loader'; // import the Loader component

const Population = () => {
  const [showPdfViewer1, setShowPdfViewer1] = useState(false);
  const [loading, setLoading] = useState(false); // add state for loading indicator

  function handleReadMoreClick() {
    setLoading(true); // set loading state to true
    setTimeout(() => {
      setShowPdfViewer1(true);
      setLoading(false); // set loading state to false when the PDF viewer is ready
    }, 5000);
  }

  return (
    <div className="image-description">
      <img src={Pop} alt='asals' className="image" />
      <div className="description">
        <h2>2023 Population Projections by County, ASAL Counties</h2>
        {loading ? (
          <Loader /> // show the loading indicator
        ) : showPdfViewer1 ? (
          <PdfViewer1 onClose={() => setShowPdfViewer1(false)} />
        ) : (
          <>
            <p>The population projection for 2023 estimates Kenya population at 51,525,602 million. ASAL counties account for 54.61% of the total population with arid counties </p>
            <button className="read-more-button" onClick={handleReadMoreClick}>Read More</button>
          </>
        )}
      </div>
    </div>
  );
};

export default Population;
